export const INITIAL_FETCH_REQUEST = "INITIAL_FETCH_REQUEST";
export const SET_FILTERS_REQUEST = "SET_FILTERS_REQUEST";
export const SET_PAGE_REQUEST = "SET_PAGE_REQUEST";
export const SET_SEARCH_VALUE_REQUEST = "SET_SEARCH_VALUE_REQUEST";
export const SET_FILTER_STATUS_REQUEST = "SET_FILTER_STATUS_REQUEST";
export const SET_ROWS_COUNT_REQUEST = "SET_ROWS_COUNT_REQUEST";
export const SET_SELECTED_REQUEST_ID = "SET_SELECTED_REQUEST_ID";
